export default __webpack_public_path__ + "static/media/bp-10.66b25d62.jpg";